function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import _JSXStyle from "styled-jsx/style";
import { PureComponent } from "react";
import PictureComponent from "/components/core/picture/picture-component";
import { componentStyles } from "./integration-badge-component.scss";
import { MIN_SCALE_VALUE, MAX_SCALE_VALUE, MIN_SCALE_TIMEOUT, MAX_SCALE_TIMEOUT, MIN_TRANSLATE_Y_VALUE, MAX_TRANSLATE_Y_VALUE, MIN_TRANSLATE_Y_TIMEOUT, MAX_TRANSLATE_Y_TIMEOUT } from "../../constants";
class IntegrationBadge extends PureComponent {
    componentDidMount() {
        this.animate();
    }
    randomNumber(min, max) {
        return Math.random() * (max - min) + min;
    }
    render() {
        const { path } = this.props;
        return /*#__PURE__*/ _jsxs("div", {
            ref: this.setPictureContainer,
            className: `jsx-${componentStyles.__hash}` + " " + "integration-badge-component",
            children: [
                /*#__PURE__*/ _jsx(PictureComponent, {
                    className: "integration-badge-image",
                    src: path
                }),
                /*#__PURE__*/ _jsx(_JSXStyle, {
                    id: componentStyles.__hash,
                    children: componentStyles
                })
            ]
        });
    }
    constructor(...args){
        super(...args);
        _define_property(this, "animate", ()=>{
            // Scale animation
            this.animatePicture({
                repeat: true,
                min: MIN_SCALE_VALUE,
                max: MAX_SCALE_VALUE,
                attribute: "scale",
                timeout: ()=>this.randomNumber(MIN_SCALE_TIMEOUT, MAX_SCALE_TIMEOUT)
            });
            // Floating animation
            this.animatePicture({
                repeat: true,
                min: MIN_TRANSLATE_Y_VALUE,
                max: MAX_TRANSLATE_Y_VALUE,
                attribute: "translateY",
                unit: "px",
                timeout: ()=>this.randomNumber(MIN_TRANSLATE_Y_TIMEOUT, MAX_TRANSLATE_Y_TIMEOUT)
            });
        });
        _define_property(this, "animatePicture", (options)=>{
            const randomTimeout = options.timeout();
            setTimeout(()=>{
                window.requestAnimationFrame(()=>{
                    const random = this.randomNumber(options.min, options.max);
                    if (this.pictureContainer) {
                        this.pictureContainer.style.transform = `${options.attribute}(${random}${options.unit || ""})`;
                    }
                    if (options.repeat) {
                        this.animatePicture(options);
                    }
                });
            }, randomTimeout);
        });
        _define_property(this, "setPictureContainer", (element)=>{
            this.pictureContainer = element;
        });
    }
}
export { IntegrationBadge as default };
